import React, {createRef, useEffect, useState} from 'react';
import DialogBox from '../../../components/DialogBox';
import {Button, Grid, TablePagination} from '@material-ui/core';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../components/TableIcons';
import AddIcon from '@material-ui/icons/AddOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {httpPaginationPost} from '../../../util/Rest';
import {defaultRows, tablePageRows} from '../../../constants/ReusableTablePagination';
import AddBillingMapping from './AddBillingMapping';
import {
  resetBillingDataData,
  resetBillingIndicatorData,
  resetData,
  setRowData,
} from '../../../redux/reducers/BillingIndicator';
import {useDispatch, useSelector} from 'react-redux';
import {resetClientInfo} from '../../../redux/reducers/clientMangement/Organizaation';

export default function BillingMappingTable({
  searchData,
  submit,
  setSubmit,
  setValue,
  setTabLabels,
}) {
  // const useStyles = makeStyles((theme) => ({
  //   'link': {
  //     color: '#320469 !important',
  //     borderBottom: '1px solid #000099',
  //   },
  //   ' & .MuiSvgIcon-root': {
  //     backgroundColor: '#320469 !important',
  //   },
  // }));
  const {status} = useSelector(({billingIndicator}) => billingIndicator);
  const [rows, setRows] = useState(defaultRows);
  // const classes1 = useStyles();
  const [editFilter, setEditFilter] = useState(false);
  // const [editData, setEditData] = useState();
  const [edit, setEdit] = useState(false);
  const [arrayLast, setArrayLast] = useState(false);
  const handleEditFilter = () => {
    setEditFilter(false);
  };
  const {roleData} = useSelector(({role}) => role);
  const roleDataAccessDc = roleData?.window?.['Billing Indicator']?.BIM;
  const dispatch = useDispatch();

  const handleEdit = (rowData) => {
    dispatch(setRowData(rowData));
    setValue(1);
    // setEditFilter(true);
    setEdit(true);
  };
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData)?.length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [searchData]);
  useEffect(() => {
    if (submit || status === 200) {
      tableRef.current.onQueryChange();
    }
  }, [status]);
  const tableRef = createRef();
  const columns = [
    {
      title: 'Billing Indicator Number',
      field: 'billingIndicatorNumber',
    },
    {
      title: 'Billing Indicator Name',
      field: 'billingIndicatorName',
    },
    {
      title: 'Company Name',
      field: 'companyName',
      render: (rowData) => (rowData?.companyName === null ? 'All' : rowData?.companyName),
    },
    {
      title: 'Corporate Name',
      field: 'corporateName',
      render: (rowData) => (rowData?.corporateName === null ? 'All' : rowData?.corporateName),
    },
    {
      title: 'Site Name',
      field: 'siteName',
      render: (rowData) => (rowData?.siteName === null ? 'All' : rowData?.siteName),
    },
    {
      title: 'Client Name',
      field: 'clientName',
      render: (rowData) => (rowData?.clientName === null ? 'All' : rowData?.clientName),
    },
  ];

  return (
    <>
      <DialogBox
        open={editFilter}
        dialogClose={handleEditFilter}
        title="Billing Indicator"
        maxWidth="lg"
      >
        <AddBillingMapping edit={edit} setEditFilter={setEditFilter} />
      </DialogBox>

      <div className="new-standard-textfields table-header table-card-header justify-content-start">
        <Button
          variant="outlined"
          className={`search-btn`}
          disabled={!roleDataAccessDc?.add}
          onClick={() => {
            dispatch(resetBillingDataData());
            dispatch(resetClientInfo());
            dispatch(resetData());
            dispatch(resetBillingIndicatorData());
            setValue(1);
            setEditFilter(true);
            setEdit(false);
            setTabLabels(['Add Billing Indicator']);
          }}
          startIcon={<AddIcon />}
        >
          Add Billing Indicator
        </Button>
      </div>
      <Grid item xs={12}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon  global-field-table new-standard-textfields actions-dropdown-table tablescroll-block">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `billing/find/all/clientbi`;
                const passValues = {
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  limit: query.pageSize ? query.pageSize : null,
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  siteName: searchData?.site?.siteName ? searchData.site?.siteName : '',
                  clientBillingId: '',
                  companyName: searchData?.company?.companyName ?
                    searchData.company?.companyName :
                    '',
                  billingIndicatorName: searchData?.billingIndicatorName?.billingIndicatorName ?
                    searchData.billingIndicatorName?.billingIndicatorName :
                    '',
                  billingIndicatorNumber: searchData?.billingIndicatorNumber?.billingIndicatorNumber ?
                    Number(searchData?.billingIndicatorNumber?.billingIndicatorNumber) :
                    '',
                  corporateName: searchData?.corporate?.corporateName ?
                    searchData.corporate?.corporateName :
                    '',
                  clientName: searchData?.serviceClient?.serviceClientName ?
                    searchData?.serviceClient?.serviceClientName :
                    '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, passValues)
                    .then((response) => {
                      setSubmit(false);
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        setArrayLast(data.length === 1);
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                    });
                }
              })
            }
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            options={{
              search: false,
              pageSize: rows,
              toolbar: false,
              toolbarButtonAlignment: 'left',
              selection: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              showTextRowsSelected: false,

              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => <EditOutlinedIcon fontSize="small" />,
                tooltip: 'Edit',
                disabled: !roleDataAccessDc?.edit,
                onClick: (e, rowData) => {
                  handleEdit(rowData);
                },
              },
            ]}
          />
        </div>
      </Grid>
    </>
  );
}
